import { createFileRoute, redirect } from "@tanstack/react-router";

// Redaksi digabung ke dalam halaman Admin (tab Blog).
export const Route = createFileRoute("/redaksi")({
  beforeLoad: () => {
    throw redirect({ to: "/admin" });
  },
});
